import React from "react";
import "./conexao.scss";
import { useInternetStatus } from "../utils/useInternetStatus.ts";

export default function InternetStatus() {
  const { status } = useInternetStatus({
    pingUrl: "/ping",
    intervalMs: 20000,
    unstableLatencyMs: 900,
    unstableJitterMs: 350,
    failToOffline: 1,
  });

  // só mostra quando tem problema
  if (status === "ok") return null;

  const isOffline = status === "offline";
  const label = isOffline ? "Sem conexão" : "Ruim";

  return (
    <div className="internet-status">
      <div className="internet-status__icon">
        {isOffline ? (
          // 1º SVG (vermelho - sem conexão)
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect width="16" height="16" fill="white" fillOpacity="0.01" />
            <path d="M8 13.5C8.55228 13.5 9 13.0523 9 12.5C9 11.9477 8.55228 11.5 8 11.5C7.44772 11.5 7 11.9477 7 12.5C7 13.0523 7.44772 13.5 8 13.5Z" fill="#DA1E28"/>
            <path d="M15 1.70705L14.2929 1L1 14.2929L1.70705 15L7.0481 9.65895C7.56144 9.48382 8.11296 9.45272 8.64275 9.56902C9.17253 9.68531 9.66031 9.94456 10.0531 10.3186L10.76 9.6118C10.0666 8.94761 9.15657 8.55625 8.1975 8.50975L9.89125 6.8159C10.7462 7.09938 11.5263 7.57187 12.1736 8.19825L12.88 7.49145C12.2415 6.87108 11.4904 6.37843 10.667 6.04L12.1654 4.5415C12.9461 4.94685 13.6628 5.46485 14.2927 6.07885L15 5.3716V5.3706C14.3734 4.75823 13.6691 4.23077 12.9052 3.80175L15 1.70705Z" fill="#DA1E28"/>
            <path d="M7.34 6.5388L8.36075 5.51805C8.2405 5.5117 8.12185 5.5 8 5.5C6.17283 5.4996 4.41851 6.21646 3.1145 7.49635L3.8213 8.20315C4.77599 7.2718 6.01442 6.68602 7.34 6.5388Z" fill="#DA1E28"/>
            <path d="M8 3.5C8.71336 3.50277 9.42382 3.59097 10.1162 3.7627L10.9375 2.9414C9.21606 2.41159 7.38331 2.35767 5.6337 2.78536C3.88409 3.21305 2.28289 4.10639 1 5.3706V5.38185L1.70215 6.084C3.37973 4.42766 5.64252 3.49924 8 3.5Z" fill="#DA1E28"/>
          </svg>
        ) : (
          // 2º SVG (laranja - instável)
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect width="16" height="16" fill="white" fillOpacity="0.01"/>
            <path d="M8 13.5C8.55228 13.5 9 13.0523 9 12.5C9 11.9478 8.55228 11.5 8 11.5C7.44772 11.5 7 11.9478 7 12.5C7 13.0523 7.44772 13.5 8 13.5Z" fill="#FF832B"/>
            <path d="M5.235 9.61674L5.9418 10.3233C6.49588 9.79562 7.23146 9.50091 7.9966 9.50004C8.76174 9.49918 9.49798 9.79222 10.0533 10.3186L10.76 9.61184C10.0174 8.89763 9.02682 8.49911 7.99649 8.50004C6.96616 8.50097 5.97632 8.90119 5.235 9.61674Z" fill="#FF832B"/>
            <path d="M3.1145 7.49639L3.8213 8.20314C4.93727 7.11217 6.43566 6.50091 7.99631 6.49998C9.55695 6.49904 11.0561 7.10851 12.1734 8.19814L12.88 7.49149C11.5754 6.21412 9.82198 5.49916 7.99615 5.5001C6.17033 5.50103 4.41779 6.21769 3.1145 7.49639Z" fill="#FF832B"/>
            <path d="M15 5.37064C13.1345 3.53121 10.6199 2.5 8 2.5C5.38013 2.5 2.86554 3.53121 1 5.37064V5.38189L1.70215 6.08404C3.37928 4.42926 5.64033 3.50105 7.9964 3.50012C10.3525 3.49918 12.6143 4.42559 14.2927 6.07904L15 5.37164V5.37064Z" fill="#FF832B"/>
          </svg>
        )}
      </div>

      <span className="internet-status__text">
        Internet:{" "}
        <span className={isOffline ? "internet-status__offline" : "internet-status__unstable"}>
          {label}
        </span>
      </span>
    </div>
  );
}
